import { useCallback, useRef, useState } from "react";
import { imageReviewApi } from "../utils/api";

/**
 * Tracks which of an entity's image URLs are known placeholders (on the confirmed
 * blocklist or flagged in an open image-review ticket). Used by the event/artist
 * edit modals to power ImageListEditor's "Remove all placeholders" bulk action.
 *
 * Call `check(urls)` when the edit modal opens; it resets and refetches. Failures
 * are swallowed (the bulk-remove button simply won't appear). Latest-wins: a slow
 * response from a previously opened entity can't overwrite the current one.
 */
export function useSuspiciousImages() {
  const [suspiciousUrls, setSuspiciousUrls] = useState([]);
  const requestId = useRef(0);

  const check = useCallback((urls) => {
    const id = ++requestId.current;
    setSuspiciousUrls([]);
    imageReviewApi
      .checkSuspicious(urls)
      .then((result) => {
        if (id === requestId.current) setSuspiciousUrls(result);
      })
      .catch(() => {});
  }, []);

  return { suspiciousUrls, check };
}
